// Schedule's pages re-read on the board's live changes, and tell the time to the minute: shared by the
// map (SchedulePages.tsx), Who's working (TeamScreen.tsx) and Time off (TimeOffScreen.tsx).
import { useEffect, useRef, useState } from 'react';
import { BOARD_EVENTS } from '../board-model.ts';
import { liveStream } from '../connection/live.ts';

/** Re-read on the board's live changes (visits, jobs, time off, holidays, non-job time), debounced. */
export function useLive(reload: () => void) {
  const again = useRef(reload);
  again.current = reload;
  useEffect(() => {
    const es = liveStream();
    let timer: ReturnType<typeof setTimeout> | undefined;
    es.addEventListener('change', (e) => {
      const { type } = JSON.parse((e as MessageEvent<string>).data) as { type: string };
      if (!BOARD_EVENTS.test(type)) return;
      clearTimeout(timer);
      timer = setTimeout(() => again.current(), 250);
    });
    return () => {
      clearTimeout(timer);
      es.close();
    };
  }, []);
}

/** Whole minutes, so "now" moves once a minute and a re-render in between draws the same. */
export function useNow(): string {
  const [now, setNow] = useState(() => new Date(Math.floor(Date.now() / 60_000) * 60_000).toISOString());
  useEffect(() => {
    const t = setInterval(
      () => setNow(new Date(Math.floor(Date.now() / 60_000) * 60_000).toISOString()),
      60_000,
    );
    return () => clearInterval(t);
  }, []);
  return now;
}
